import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import PropTypes from "prop-types";
import Navbar from "../common/Navbar";
import Footer from "../common/Footer";
import InfoBox from "./InfoBox";
import { updateMemberActionIsRead, getMemberActions } from "../../actions/memberActions";
import { isUserAuthenticated } from "../../helpers/authUtils";
import './userInfo.css';

class UserInfo extends Component {
  componentDidMount = () => {
    this.props.updateMemberActionIsRead();
    this.props.getMemberActions();
  };

  renderRedirectToRoot = () => {
    const isAuthTokenValid = isUserAuthenticated();
    if (!isAuthTokenValid) {
      return <Redirect to="/members" />;
    }
  };

  render() {
    const isAuthTokenValid = isUserAuthenticated();
    const { actionLogs } = this.props;
    
    let infoBox;
    if (actionLogs.length === 0) {
      infoBox = null;
    } else {
      infoBox = actionLogs
        .map(info => <InfoBox key={info.id} info={info} />);
    }

    return (
      <Fragment>
        {this.renderRedirectToRoot()}
        {(isAuthTokenValid) && (
        <div id="page">
          <Navbar />
          <aside className="colorlib-breadcrumbs">
            <div className="container">
                <div className="row">
                    <div className="col-md-12 breadcrumbs text-center">
                        <h2>會員訊息</h2>
                        <p><span>Member Information</span></p>
                    </div>
                </div>
            </div>
          </aside>
          <div className="colorlib">
            <div className="container">
            {infoBox}
            </div>
          </div>
          <Footer showAgreement={true} />
        </div>
        )}
      </Fragment>
    );
  }
}

UserInfo.propTypes = {
  updateMemberActionIsRead: PropTypes.func.isRequired,
  getMemberActions: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  isRead: state.member.isRead,
  actionLogs: state.member.actionLogs
});

export default connect(mapStateToProps, { updateMemberActionIsRead, getMemberActions })(UserInfo);